var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#3D9F4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1666 28.3333H39.8906C44.9693 28.3333 47.5087 28.3333 48.4726 29.2455C49.3059 30.0339 49.6752 31.1954 49.4502 32.3203C49.1899 33.6217 47.1168 35.0881 42.9704 38.0209L36.1961 42.8124C32.0498 45.7452 29.9766 47.2116 29.7163 48.513C29.4913 49.6378 29.8606 50.7994 30.6939 51.5878C31.6578 52.5 34.1972 52.5 39.2759 52.5H40.8333M33.3333 28.3333C33.3333 31.0947 31.0947 33.3333 28.3333 33.3333C25.5718 33.3333 23.3333 31.0947 23.3333 28.3333C23.3333 25.5719 25.5718 23.3333 28.3333 23.3333C31.0947 23.3333 33.3333 25.5719 33.3333 28.3333ZM56.6666 51.6666C56.6666 54.4281 54.428 56.6666 51.6666 56.6666C48.9052 56.6666 46.6666 54.4281 46.6666 51.6666C46.6666 48.9052 48.9052 46.6666 51.6666 46.6666C54.428 46.6666 56.6666 48.9052 56.6666 51.6666Z",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.38da9b0ec630de29b4c112c3ff186aa6.svg";
export { ForwardRef as ReactComponent };